import React from 'react';
import Select from 'react-select';
import {
  compose,
  withStateHandlers,
  setPropTypes,
  withHandlers,
  defaultProps,
  withPropsOnChange,
} from 'recompose';
import { ApiClient } from 'services';
import PropTypes from 'prop-types';
import { debounce, isArray, isFinite, noop, isString } from 'lodash';

const enhance = compose(
  setPropTypes({
    url: PropTypes.string.isRequired,
  }),
  defaultProps({
    valueKey: 'id',
    autoload: true,
    labelKey: 'name',
    onChange: noop,
    debounceTimeout: 500,
    minLength: 1,
    convertStringValueToObject: true,
  }),
  withPropsOnChange(
    ['initialDisplay'],
    ({ initialValue, valueKey, labelKey, convertStringValueToObject }) => {
      if (!convertStringValueToObject) return null;

      if (isString(initialValue)) {
        return { initialValue: { [labelKey]: initialValue, [valueKey]: null } };
      }

      return null;
    }
  ),
  withStateHandlers(props => ({ value: props.initialValue || null }), {
    onChange: (_, { onChange }) => tmpValue => {
      // react-reselect tries to set value to an empty array for some reason...
      let value = tmpValue;
      if (isArray(value)) value = null;
      onChange(value);
      return { value };
    },
  }),
  withHandlers(({ url, debounceTimeout, minLength }) => {
    const loadOptions = debounce((search, callback) => {
      if (isFinite(minLength) && search.length < minLength) {
        callback(null, { options: [] });
        return;
      }
      const client = new ApiClient();
      client
        .get(url, { params: { search } })
        .tap(resp => {
          callback(null, { options: resp.data });
        })
        .catch(callback);
    }, debounceTimeout);

    return {
      loadOptions: () => loadOptions,
    };
  })
);

const AutoComplete = ({
  onChange,
  value,
  autoload,
  valueKey,
  labelKey,
  loadOptions,
  ...props
}) => (
  <Select.Async
    value={value}
    multi={false}
    autoload={autoload}
    onChange={onChange}
    valueKey={valueKey}
    labelKey={labelKey}
    loadOptions={loadOptions}
    {...props}
  />
);

export default enhance(AutoComplete);



// WEBPACK FOOTER //
// ./src/components/common/Forms/AutoComplete.jsx